// extracted by mini-css-extract-plugin
export var container = "_oc-0";
export var dotAnimation = "_oc-2";
export var dotsLoading = "_oc-1";